import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProcessWindow from '@/components/process/ProcessWindow.vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "ProcessListTable",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProcessWindow))
}
}

})